import { MenuItem as MenuItemBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuItem = styled(MenuItemBase)`
  font-size: ${(p) => p.theme.typography.caption.fontSize};

  &:hover,
  &.Mui-selected {
    /* color: ${(p) => p.theme.palette.primary[500]}; */
    /* background-color: ${(p) => p.theme.palette.primary[50]}; */
  }
`;
